import type { App, Directive } from "vue";

const e2e: Directive = {
  mounted(el, binding) {
    const value = binding.value
      ? `${binding.arg}:${binding.value}`
      : binding.arg;
    el.setAttribute("data-e2e", value);
  },
};

export default {
  install(app: App) {
    app.directive("e2e", e2e);
  },
};
